import { render, staticRenderFns } from "./ParticaWebsiteSecurity.vue?vue&type=template&id=756eaede&"
import script from "./ParticaWebsiteSecurity.vue?vue&type=script&lang=ts&"
export * from "./ParticaWebsiteSecurity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports